export const UNKNOWN_LICENSE = 'unknown_license';
export const EXCEEDED_SESSIONS_LIMIT = 2;
export const SIGNUP_EVENT_CUTOFF = new Date('2025-04-28T00:00:00.000Z');
